(function () {
  if (window.__amazonPayButtonInit) return;
  window.__amazonPayButtonInit = true;

  function getAmazonUrl(sectionId, variantId) {
    var mapScript = document.querySelector('[data-amazon-pay-map="' + sectionId + '"]');
    if (!mapScript) return '';
    try {
      var map = JSON.parse(mapScript.textContent);
      return map[variantId] || '';
    } catch (e) {
      return '';
    }
  }

  function toggleAmazonButton(sectionId, variantId) {
    var wrapper = document.getElementById('AmazonPayButton-' + sectionId);
    if (!wrapper) return;

    var formButtons = document.getElementById('ProductFormButtons-' + sectionId);
    var priceBlock = document.getElementById('price-' + sectionId);
    var link = wrapper.querySelector('.amazon-pay-button__link');
    var amazonUrl = getAmazonUrl(sectionId, variantId);

    // Flag the product block so CSS can hide the subscription / one-time purchase widgets too
    var productInfo = wrapper.closest('product-info');
    if (productInfo) {
      if (amazonUrl) productInfo.setAttribute('data-amazon-mode', 'true');
      else productInfo.removeAttribute('data-amazon-mode');
    }

    if (amazonUrl) {
      if (link) link.setAttribute('href', amazonUrl);
      wrapper.classList.remove('hidden');
      if (formButtons) formButtons.classList.add('hidden');
      if (priceBlock) priceBlock.classList.add('hidden');
    } else {
      wrapper.classList.add('hidden');
      if (formButtons) formButtons.classList.remove('hidden');
      if (priceBlock) priceBlock.classList.remove('hidden');
    }
  }

  function applyInitialState(wrapper) {
    var sectionId = wrapper.id.replace('AmazonPayButton-', '');
    var variantId = wrapper.dataset.initialVariantId;
    toggleAmazonButton(sectionId, variantId);
  }

  function scanAndInit(root) {
    (root || document).querySelectorAll('[id^="AmazonPayButton-"]').forEach(applyInitialState);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanAndInit(document);
  });

  // Handles Quick View modal: content is injected after page load
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.id && node.id.indexOf('AmazonPayButton-') === 0) applyInitialState(node);
        if (node.querySelectorAll) scanAndInit(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Handles variant change on PDP and inside Quick View modal
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (!event || !event.data || !event.data.variant || !event.data.sectionId) return;
      var sectionId = event.data.sectionId;
      // Quick View renders with IDs prefixed "quickadd-" while the event carries the original section id
      var quickAddOpen = document.querySelector('quick-add-modal[open]');
      var quickAddId = 'quickadd-' + sectionId;
      if (quickAddOpen && document.getElementById('AmazonPayButton-' + quickAddId)) {
        toggleAmazonButton(quickAddId, event.data.variant.id);
      } else {
        toggleAmazonButton(sectionId, event.data.variant.id);
      }
    });
  }
})();
